import { render, staticRenderFns } from "./ProjectCommissionRecovery.vue?vue&type=template&id=6c3712b2&scoped=true"
import script from "./ProjectCommissionRecovery.vue?vue&type=script&lang=js"
export * from "./ProjectCommissionRecovery.vue?vue&type=script&lang=js"
import style0 from "./ProjectCommissionRecovery.vue?vue&type=style&index=0&id=6c3712b2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3712b2",
  null
  
)

export default component.exports